module.exports = {
    formQueryString (searchObj) {
        return '?' + Object.keys(searchObj).reduce((acc, each) => {
            if (searchObj[each]) {
                acc.push(`${each}=${searchObj[each]}`);
            }
            return acc;
        }, []).join('&');
    },
    capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    },
    dateConvert (date) {
        const convertedDate = new Date(date);
        return convertedDate.toLocaleDateString();
    },
    getDate (time=null) {
        const date = time ? new Date(time) : new Date();
        const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        return date.getDate()+' '+months[date.getMonth()]+' '+date.getFullYear();
    },
    getInitials (string) {
        const parts = string.split(' ');
        const max = parts.length < 2 ?  parts.length : 2;
        let result = '';
        for (let i = 0; i < max; i++) {
            result += parts[i].charAt(0).toUpperCase();
        }
        return result;
    },
    stripHtmlTags (string) {
        const div = document.createElement("div");
        div.innerHTML = string;
        return div.innerText;
    },
    localStore: {
        AddElementInStore (key, value){
            if (!value || !key){
                return;
            }
            if (typeof(Storage) !== "undefined") {
                let s = localStorage.getItem(key) || "";
                if (!s){
                    localStorage.setItem(key, value);
                } else {
                    s = s+','+value;
                    localStorage.setItem(key, s);
                }
                return 1;
            }
        },
        popElementInStore (key, value) {
            if (!value || !key){
                return;
            }
            if (typeof(Storage) !== "undefined") {
                let s = localStorage.getItem(key) || "";
                const arr = s.split(",");
                for (let i = arr.length - 1; i >= 0; i--) {
                    if (arr[i] === value) {
                        arr.splice(i, 1);
                    }
                }
                s = arr.join(",");
                localStorage.setItem(key, s);
                return 1;
            }
        },
        getStoreData (key) {
            if (!key){
                return;
            }
            if (typeof(Storage) !== "undefined") {
                const s = localStorage.getItem(key) || "";
                let arr = [];
                if (s){
                    arr = s.split(",");
                }
                return arr;
            }
        },
        deleteStore (key) {
            if (!key){
                return;
            }
            if (typeof(Storage) !== "undefined") {
                localStorage.removeItem(key);
            }
            return 1;
        }
    },
    loadGA () {
        const imported = document.createElement('script');
        imported.src = 'https://teja10.kuikr.com/public/core/dist/horizontal/horizontal-q-ga-9f46ef10d0a122383c5e.js';
        document.body.appendChild(imported);
        window._gaq = window._gaq || [];
        window._gaq.push(['_setAccount', checkIsMobile() ? 'UA-5568615-7' : 'UA-5568615-1']);
        window._gaq.push(['_gat._forceSSL']); 
        window._gaq.push(['_trackPageview']);
    },
    pushToDataLayer (data) {
        if (typeof dataLayer !== "undefined" && window.dataLayer) {
            window.dataLayer.push(data);
        }
    },
    convertPriceToIndFormat (price) {
        if (typeof price === 'undefined') { 
            return 0;
        }
        price = price.toString();
        let lastThree = price.substring(price.length-3);
        const otherNumbers = price.substring(0, price.length-3);
        if (otherNumbers !== '')
            lastThree = ',' + lastThree;
        const res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",");
        return res+lastThree;
    },

    convertPriceToKFormat: function (num) {
        if (typeof num === 'undefined') { 
            return '';
        }
        if (num < 1000) {
            return num;
        }
        if(num < 99999) {
            return parseFloat((num/1000).toFixed(1)) + "K";
        }
        if( num > 99999) {
            return parseFloat((num/100000).toFixed(2)) + "L";
        }
    },

    bigBrotherEvents (data, event, source) {
        if (typeof _paqv3 !== "undefined") {
            bigBrotherEventsDup(data, event, source);
        } else {
            setTimeout(() => {
                if (typeof _paqv3 !== "undefined") {
                    bigBrotherEventsDup(data, event, source);
                }
            }, 2000);
        }
    },
    isRequired (inputVal) {
        if (!inputVal || (inputVal === '' || (Array.isArray(inputVal) && inputVal.length <= 0))) {
            return true;
        }
        return false;
    },
    isMobileValid (inputVal) {
        if (!(inputVal) || (!/^\d{10}$/.test(inputVal) || !/^[9876].*/.test(inputVal))) {
            return true;
        }
        return false;
    },
    isEmailValid (inputVal) {
        if (!(inputVal) || !(/^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/.test(inputVal))) {
            return true;
        }
        return false;
    },
    isMobileRequest () {
        return checkIsMobile();
    },
    isValidPincode (pincode){
        if (!(/^[1-9][0-9]{5}$/.test(pincode))) {
            return true;
        }
        return false;
    },
    triggerPageView () {
        window._gaq = window._gaq || [];
        window._gaq.push(['_trackPageview']);
    },
    extractImageUrl (image, type) {
        if (image && image[type] && image[type].url) {
            return image[type].url;
        } else if (image.lg && image.lg.url) {
            return image.lg.url;
        } else if (image.nr && image.nr.url) {
            return image.nr.url;
        } else if (image.gv && image.gv.url) {
            return image.gv.url;
        } else if (image.sm && image.sm.url) {
            return image.sm.url;
        } else if (image.sq && image.sq.url) {
            return image.sq.url;
        }
        if (type !== "nr") {
            const url = image.match(/(.*)\.(.*)/) ;
            return `${url[1]}_${type}.${url[2]}`;
        }
        return  image;
                
            
    },
    isEmpty (obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key))
                return false;
        }
        return true;
    },
    loadDynamicAd (gAdsSlot, index=0) {
        window.QDFP = window.QDFP || {};
        window.QDFP.dynamicSlots = window.QDFP.dynamicSlots || [];
        if (typeof window.QDFP.getAdForDivId === "function") {
            window.QDFP.getAdForDivId(gAdsSlot, index);
        } else {
            window.QDFP.dynamicSlots.push(gAdsSlot);
        }
    },
    linkHref (href) {
        return href.replace('https://www.quikr.com', '');
    },
    getAutoFillName (name) {
        return (name !== '' && name) || localStorage.getItem('autofill_name') || '';
    },
    getAutoFillEmail (email) {
        return (email && email.length>0 && email[0]) || localStorage.getItem('autofill_email') || null;
    },
    getAutoFillMobile (mobile) {
        return (mobile && mobile.length>0 && mobile[0].toString()) || localStorage.getItem('autofill_mobile') || null ;
    },
    getQueryParams: function (href) {
        const hrefarr = href.split('?');
        const queryString =  hrefarr.length>1 ? hrefarr[1] : null;
        let queryparams = [];
        if (queryString) {
            queryparams = queryString.split('&').map((param)=>param.split('=')).reduce((values,[key,value])=>{values[key]=value;return values},{});
        }
        return queryparams;
    },
    convertMilliSecondsToHumanReadableForm: function (seconds) {
        seconds = seconds/1000;
        const numdays = Math.floor((seconds % 31536000) / 86400); 
        const numhours = Math.floor(((seconds % 31536000) % 86400) / 3600);
        const numminutes = Math.floor((((seconds % 31536000) % 86400) % 3600) / 60);
        const numseconds = Math.floor((((seconds % 31536000) % 86400) % 3600) % 60);
        let timeString = numdays ? `${numdays}d ` : '';
        timeString += numhours ? `${numhours}h ` : '';
        timeString += numminutes ? `${numminutes}m ` : '';
        timeString += numseconds ? `${numseconds}s` : '';
        return timeString;
    },
    getTimeDiffInMilliSeconds (endTime) {
        const currentTime = new Date().getTime();
        const seconds = endTime - currentTime;
        return seconds;
    }
}

const bigBrotherEventsDup = (data, event, source) => {
    const postData = JSON.stringify(data);
    window._paqv3.push(['_sendEventApiData', event, source, postData]);
};

const checkIsMobile = () =>  {
    if (typeof window !== "undefined" && typeof window.__PRELOADED_STATE__ !== 'undefined' && typeof window.__PRELOADED_STATE__.isMobile !== 'undefined') {
        return window.__PRELOADED_STATE__.isMobile;
    }
    return true;
};




// WEBPACK FOOTER //
// ../q-cars/src/utils/CommonHelper.js